import React from 'react';

import { Badge, Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// ---------------------------------------------------------------------------- styles
const TabsContainer = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== 'noBorder',
})(({ theme, noBorder }) => ({
  borderBottom: noBorder ? 'none' : `1px solid #D9D9D9`,
}));
const TabItem = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'gap' || prop !== 'size',
})(({ theme, gap, size }) => ({
  color: theme.palette.neutral400.main,
  padding: 0,
  minWidth: 0,
  marginRight: gap ? `${gap} !important` : '24px !important',
  textTransform: 'none',
  '&:last-child': {
    marginRight: '0 !important',
  },
  '&.Mui-selected': {
    color: theme.palette.primaryBrandPurwadhika.main,
  },
}));
const TabPanelBox = styled(Box)(() => ({
  marginTop: '1.5rem',
}));

const CircleBox = styled(Box)(({ theme }) => ({
  width: '24px',
  height: '24px',
  backgroundColor: theme.palette.error500.main,
  borderRadius: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
// ---------------------------------------------------------------------------- components
const PWDKTabPanel = ({ value, active, children, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== active}
      aria-labelledby="tab-panel"
      {...other}
    >
      {value === active && <TabPanelBox>{children}</TabPanelBox>}
    </div>
  );
};

const PWDKTabs = ({
  tabMenus,
  tabGap,
  variant,
  indicatorPosition,
  indicatorHeight,
  active,
  itemStyle,
  onChange,
  noBorder,
  scrollButtons,
  ...other
}) => {
  const indicatorStyles = {
    sx: {
      [indicatorPosition || 'bottom']: 0,
      height: indicatorHeight || '2px',
      backgroundColor: 'primaryBrandPurwadhika.main',
    },
  };
  return (
    <TabsContainer
      value={active}
      onChange={onChange}
      TabIndicatorProps={indicatorStyles}
      variant={variant || 'standard'}
      aria-label="tabs-menu"
      noBorder={noBorder}
      scrollButtons={scrollButtons || false}
      // allowScrollButtonsMobile
      {...other}
    >
      {React.Children.toArray(
        tabMenus?.map(({ label, value, badge, notification }) => (
          <TabItem
            label={
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography typography={{ md: 'subheading4', xs: 'caption1' }}>
                  {label}
                </Typography>
                {badge}
                {notification > 0 && (
                  <CircleBox>
                    <Typography typography="caption1" color="error300.main">
                      {notification}
                    </Typography>
                  </CircleBox>
                )}
              </Stack>
            }
            value={value || label}
            gap={tabGap}
            disableRipple
            sx={{ ...itemStyle }}
          />
        )),
      )}
    </TabsContainer>
  );
};
export default PWDKTabs;
export { PWDKTabPanel };
